import { createSlice } from "@reduxjs/toolkit"
import {
  getAllOrders,
  getOrderDetails,
  updateOrderStatus,
} from "store/actions/orderAction"

const initialState = {
  loading: true,
  isLoading: false,
  itemsPerPage: 50,
  totalPages: null,
  isUpdating: false,
  currentPage: 1,
  orders: [],
  orderDetails: {},
}

const usersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload
    },
  },

  extraReducers: builder => {
    // GET ALL ORDERS
    builder
      .addCase(getAllOrders.pending, state => {
        state.loading = true
      })
      .addCase(getAllOrders.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.orders = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllOrders.rejected, (state, action) => {
        state.loading = false
      })

    // GET ORDER DETAILS
    builder
      .addCase(getOrderDetails.pending, state => {
        state.loading = true
      })
      .addCase(getOrderDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.orderDetails = data
        }
      })
      .addCase(getOrderDetails.rejected, (state, action) => {
        state.loading = false
      })

    // UPDATE BOOKING STATUS
    builder
      .addCase(updateOrderStatus.pending, state => {
        state.isLoading = true
      })
      .addCase(updateOrderStatus.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          const { id, status } = action.meta.arg
          state.orders = state.orders.map(item =>
            item._id === id ? { ...item, orderStatus: Number(status) } : item
          )
        }
      })
      .addCase(updateOrderStatus.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export const { setItemsPerPage } = usersSlice.actions

export default usersSlice.reducer
